// src/hooks/useSettingsLocal.ts
import { useEffect, useState } from 'react';
import {
  DashboardSettings,
  getSettingsFromLocal,
  setSettingsToLocal,
  mergeWithDefaults,
} from '../stores/settingsLocal';

export function useSettingsLocal() {
  const [settings, setSettings] = useState<DashboardSettings>(() => getSettingsFromLocal());

  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === 'ui.dashboard.settings') {
        setSettings(getSettingsFromLocal());
      }
    };
    const onUpdated = () => setSettings(getSettingsFromLocal());

    window.addEventListener('storage', onStorage);
    window.addEventListener('settings:updated', onUpdated);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener('settings:updated', onUpdated);
    };
  }, []);

  const update = (next: DashboardSettings | ((prev: DashboardSettings) => DashboardSettings)) => {
    const value = typeof next === 'function' ? (next as any)(settings) : next;
    const merged = mergeWithDefaults(value);
    setSettings(merged);
    setSettingsToLocal(merged);
  };

  return { settings, setSettings: update };
}
